import { ContractType } from '../../enums/ContractType'
import Badge from '../common/badge/Badge'
import { BadgeColor } from '../common/badge/badgeTypes'

interface Props {
    contractType: ContractType
}

export default function ContractTypeBadge({
    contractType,
}: Props): React.JSX.Element {
    return (
        <>
            {contractType === ContractType.Permanent && (
                <Badge color={BadgeColor.BrandBlue}>PERMANENT</Badge>
            )}
            {contractType === ContractType.Contract && (
                <Badge color={BadgeColor.Cyan}>CONTRACT</Badge>
            )}
        </>
    )
}
